module.exports = __webpack_public_path__ + "static/img/he6.2b36f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he6.png
// module id = XAlP
// module chunks = 1